import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Tooltip } from '@material-ui/core';
import { vendaApi } from 'app/services/api/vendaApi';
import { mapVendaApiToCalculoTotaisRequest } from 'app/main/venda/utils/vendaCalculoTotaisMapper';
import React, { useEffect, useState } from 'react';
import { FaInfo } from 'react-icons/fa';

const VisualizarProdutoServico = ({ venda, styles, getCurrency }) => {
  const [page, setPage] = useState(0);
  const [subtotaisPorIndice, setSubtotaisPorIndice] = useState({});
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    let cancelled = false;

    const carregarSubtotais = async () => {
      if (!venda?.produtosServicos?.length) {
        setSubtotaisPorIndice({});
        return;
      }

      try {
        const payload = mapVendaApiToCalculoTotaisRequest(venda);
        const { data } = await vendaApi().calcularTotais(payload);
        if (cancelled) {
          return;
        }

        const map = {};
        (data?.produtosServicos || []).forEach((linha) => {
          map[linha.indice] = linha.subtotal;
        });
        setSubtotaisPorIndice(map);
      } catch (err) {
        if (!cancelled) {
          setSubtotaisPorIndice({});
        }
      }
    };

    carregarSubtotais();

    return () => {
      cancelled = true;
    };
  }, [venda?.id]);

  const getSubTotal = (values, indice) => {
    if (subtotaisPorIndice[indice] != null && subtotaisPorIndice[indice] !== '') {
      return Number(subtotaisPorIndice[indice]);
    }
    if (values?.subtotalCalculado != null && values.subtotalCalculado !== '') {
      return Number(values.subtotalCalculado);
    }
    if (!values?.quantidade || !values?.valor) {
      return 0;
    }
    return values.valor * values.quantidade;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }} className="mb-16">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" className={styles.cellProdutoServico}>
                Nome do produto/serviço
              </TableCell>
              <TableCell />
              <TableCell align="center">Quantidade</TableCell>
              <TableCell align="right">Valor (R$)</TableCell>
              <TableCell align="right">Subtotal (R$)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {venda?.produtosServicos
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((produtoServico, i) => {
                const indice = page * rowsPerPage + i;
                let tooltip = '';
                if (produtoServico?.produto?.descricaoDetalhada) {
                  tooltip = produtoServico?.produto?.descricaoDetalhada;
                } else if (produtoServico?.servico?.descricaoDetalhada) {
                  tooltip = produtoServico?.servico?.descricaoDetalhada;
                }

                return (
                  <TableRow key={produtoServico?.id || indice}>
                    <TableCell component="th" align="left">
                      {produtoServico?.produto?.nome ||
                        (produtoServico?.servico?.codigo
                          ? `${produtoServico?.servico?.codigo} - ${produtoServico?.servico?.descricao}`
                          : produtoServico?.servico?.descricao)}
                    </TableCell>
                    <TableCell>
                      {!!tooltip && (
                        <Tooltip title={tooltip} placement="right-end">
                          <button type="button" onClick={() => {}}>
                            <FaInfo size={16} />
                          </button>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell align="center">{produtoServico?.quantidade}</TableCell>
                    <TableCell align="right">{getCurrency(produtoServico?.valor).replace('R$', '')}</TableCell>
                    <TableCell align="right">
                      {getCurrency(getSubTotal(produtoServico, indice)).replace('R$', '')}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>

        {venda?.produtosServicos?.length > 5 && (
          <TablePagination
            component="div"
            className="pb-0"
            count={venda?.produtosServicos?.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage={false}
            page={page}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            onChangePage={handleChangePage}
            rowsPerPageOptions={[]}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default VisualizarProdutoServico;
